interface ConversionConfig {
  send_to: string
  value?: number
  currency?: string
}

interface ConversionConfigs {
  [key: string]: ConversionConfig
}

interface ConversionOptions {
  value?: number
  currency?: string
  [key: string]: any
}

declare global {
  interface Window {
    dataLayer: any[]
    gtag: (...args: any[]) => void
    gtag_report_conversion: (
      url: string,
      conversion_id: string,
      options?: ConversionOptions,
    ) => boolean
  }
}

export function useGoogleAnalytics() {
  const initGoogleAnalytics = () => {
    window.dataLayer = window.dataLayer || []
    window.gtag = function () {
      window.dataLayer.push(arguments)
    }
    window.gtag('js', new Date())

    window.addEventListener('load', function () {
      const gaScript = document.createElement('script')
      gaScript.async = true
      gaScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-TNP3396NGS'
      document.head.appendChild(gaScript)

      // GA4
      window.gtag('config', 'G-TNP3396NGS')

      // Google Ads
      window.gtag('config', 'AW-944830471')
      window.gtag('config', 'AW-16671009174')
      window.gtag('config', 'AW-16672236042')
      window.gtag('config', 'AW-16717395757')
      window.gtag('config', 'AW-16559668640')
      window.gtag('config', 'AW-1655966840')
    })
  }

  const initConversionTracking = () => {
    const conversion_configs: ConversionConfigs = {
      'AW-16671009174': { send_to: 'AW-16671009174/q39ACJK1i8oZEJbTrY0-' },
      'AW-16717395757': {
        send_to: 'AW-16717395757/SD7YCKi7h9cZEK3uvKM-',
        value: 1.0,
        currency: 'CNY',
      },
      'AW-16672236042': { send_to: 'AW-16672236042/nurECL2d9soZEIrE-I0-' },
      'AW-16559668640': {
        send_to: 'AW-16559668640/hymeCI_7kMwZEKD7odg9',
        value: 1.0,
        currency: 'USD',
      },
      'AW-1655966840': {
        send_to: 'AW-16559668640/f5kiCNKXsLAaEKD7odg9',
        value: 1.0,
        currency: 'USD',
      },
      'AW-16559668640-1': {
        send_to: 'AW-16559668640/y5NBCJKd8LIaEKD7odg9',
        value: 1.0,
        currency: 'USD',
      },
    }

    window.gtag_report_conversion = (
      url: string,
      conversion_id: string,
      options: ConversionOptions = {},
    ) => {
      const config = {
        ...conversion_configs[conversion_id],
        ...options,
        event_id: `${conversion_id === 'AW-16559668640-1' ? 'AW-16559668640' : conversion_id}_${Date.now()}`,
      }

      window.gtag('event', 'conversion', config)
      return false
    }
  }

  // Initialize both Google Analytics and Conversion Tracking
  initGoogleAnalytics()
  initConversionTracking()
  return {
    gtag: window.gtag,
    gtag_report_conversion: window.gtag_report_conversion,
  }
}
